import api from "./api.config";

// Panel APIs
export const panelAPI = {
  getAllPanels: async (params = {}) => {
    const response = await api.get("/panels", { params });
    return response.data;
  },

  getPublicPanels: async (params = {}) => {
    const response = await api.get("/panels/public", { params });
    return response.data;
  },

  getPanelById: async (id) => {
    const response = await api.get(`/panels/${id}`);
    return response.data;
  },

  getAll: async (params = {}) => {
    const response = await api.get("/panels", { params });
    return response.data;
  },

  getById: async (id) => {
    const response = await api.get(`/panels/${id}`);
    return response.data;
  },

  create: async (data) => {
    const response = await api.post("/panels", data);
    return response.data;
  },

  update: async (id, data) => {
    const response = await api.put(`/panels/${id}`, data);
    return response.data;
  },

  delete: async (id) => {
    const response = await api.delete(`/panels/${id}`);
    return response.data;
  },

  assignMembers: async (id, memberIds, role = "MEMBER") => {
    const response = await api.post(`/panels/${id}/members`, {
      memberIds,
      role,
    });
    return response.data;
  },

  updateStatus: async (id, status) => {
    const response = await api.put(`/panels/${id}/status`, {
      panelStatus: status,
    });
    return response.data;
  },

  publish: async (id) => {
    const response = await api.post(`/panels/${id}/publish`);
    return response.data;
  },

  publishPanel: async (id) => {
    const response = await api.post(`/panels/${id}/publish`);
    return response.data;
  },

  createPanel: async (data) => {
    const response = await api.post("/panels", data);
    return response.data;
  },

  updatePanelStatus: async (id, status) => {
    const response = await api.put(`/panels/${id}/status`, {
      panelStatus: status,
    });
    return response.data;
  },

  assignMember: async (panelId, memberId, role = "MEMBER") => {
    const response = await api.post(`/panels/${panelId}/members`, {
      memberIds: [memberId],
      role,
    });
    return response.data;
  },

  getClientPanels: async () => {
    // Get panels for client members (all panels they can see)
    const response = await api.get("/panels");
    return response.data;
  },

  getMemberPanels: async () => {
    // Get panels for members (all panels they're part of)
    const response = await api.get("/panels");
    return response.data;
  },

  getCommunityPanels: async () => {
    // Get panels for community members (public panels)
    const response = await api.get("/panels", {
      params: { visibility: "PUBLIC" },
    });
    return response.data;
  },

  // Rep management methods
  getPanelReps: async (panelId) => {
    const response = await api.get(`/panels/${panelId}/reps`);
    return response.data;
  },

  addRepToPanel: async (panelId, userId, repRole) => {
    const response = await api.post(`/panels/${panelId}/reps/add`, {
      userId,
      repRole,
    });
    return response.data;
  },

  createAndAddRep: async (panelId, repData) => {
    const response = await api.post(`/panels/${panelId}/reps/create`, repData);
    return response.data;
  },

  removeRepFromPanel: async (panelId, userId) => {
    const response = await api.delete(`/panels/${panelId}/reps/${userId}`);
    return response.data;
  },

  getUsersForInvite: async (params = {}) => {
    const response = await api.get("/panels/users/invite", { params });
    return response.data;
  },

  submitPanelConflictOfInterest: async (panelId, data) => {
    const response = await api.post(
      `/panels/${panelId}/conflict-of-interest`,
      data
    );
    return response.data;
  },
};

export default panelAPI;
